<template>
  <Layout>
    <div class="row">
      <PageHeader class="col-11" title="Company Management" />
    </div>

    <!-- Search and Create new package -->
    <div class="row mb-2">
      <div class="col-sm-4">
        <div class="search-box me-2 mb-2 d-inline-block">
          <div class="position-relative">
            <b-form-input
              v-model="filter"
              type="search"
              class="form-control"
              placeholder="Search Company"
            ></b-form-input>
            <i class="bx bx-search-alt search-icon"></i>
          </div>
        </div>
      </div>
      <div class="col-sm-8">
        <div class="text-sm-end">
          <button
            type="button"
            @click="showAddCompanyModal"
            class="btn btn-info btn-rounded mb-2 me-2"
          >
            <i class="mdi mdi-plus me-1"></i
            >{{ $t("menuitems.administration.list.company.list.add") }}
          </button>
        </div>
      </div>
    </div>

    <!-- Company Table -->
    <div class="table-responsive mb-0">
      <b-table
        class="datatables"
        :items="allCompanies"
        :fields="fields"
        responsive="sm"
        :per-page="0"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
      >
        <template #cell(created_at)="row">
          <span
            >{{ new Date(row.item.created_at).toDateString() }}
            {{ new Date(row.item.created_at).toLocaleTimeString() }}</span
          >
        </template>

        <template #cell(is_active)="row">
          <span :class="`badge ${getStatusClass(row.item.is_active)}`">{{
            row.item.is_active ? "Active" : "Disabled"
          }}</span>
        </template>

        <template #cell(types)="row">
          <span>{{
            getSplitTypes(row.item.types.map((e) => e.type_name))
          }}</span>
        </template>

        <template #cell(actions)="row">
          <!-- <b-button
            size="sm"
            variant="primary"
            class="m-1"
            @click="showUpdateModal(row.item)"
          >
            Modify
          </b-button> -->
          <b-button
            size="sm"
            variant="danger"
            class="m-1 w-100"
            @click="disableCompany(row.item.company_name)"
            v-show="row.item.is_active === 1"
          >
            Disable
          </b-button>
          <b-button
            size="sm"
            variant="success"
            class="m-1 w-100"
            @click="enableCompany(row.item.company_name)"
            v-show="row.item.is_active === 0"
          >
            Activate
          </b-button>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end mb-3">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>

    <!-- Create company modal -->
    <b-modal
      id="create-new-company-modal"
      title="Create New Company"
      title-class="font-18"
      no-close-on-backdrop
      hide-footer
      centered
    >
      <template #modal-header>
        <div><h5>Add New Company</h5></div>
        <div>
          <button
            class="btn btn-sm btn-outline-danger"
            @click="$bvModal.hide('create-new-company-modal')"
          >
            Cancel
          </button>
        </div>
      </template>
      <form @submit.prevent="createNewCompany">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label>Company Name</label>
              <input
                placeholder="Enter Company Name"
                v-model="createCompanyObj.companyName"
                type="text"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label>Company Type</label>
              <v-select
                class="style-chooser"
                v-model="createCompanyObj.types"
                :options="companyTypes"
                :reduce="(type) => type.id"
                label="type_name"
                multiple
              ></v-select>
            </div>
          </div>
        </div>

        <hr />

        <!-- BUTTON -->
        <div class="row">
          <div class="col-12">
            <div class="mt-2 text-center">
              <button type="submit" class="btn btn-primary me-1 w-50">
                Create Company <i class="bx bx-rocket ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- Updaate company modal -->
    <b-modal
      id="update-company-modal"
      title-class="font-18"
      no-close-on-backdrop
      hide-footer
      centered
    >
      <template #modal-header>
        <div><h5>Modify Company</h5></div>
        <div>
          <button
            class="btn btn-sm btn-outline-danger"
            @click="$bvModal.hide('update-company-modal')"
          >
            Cancel
          </button>
        </div>
      </template>
      <form @submit.prevent="updateCompanyDetails">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label>Company Name</label>
              <input
                placeholder="Enter Company Name"
                v-model="updateCompanyObj.companyName"
                type="text"
                class="form-control inp-bg"
                required
              />
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label>Company Type</label>
              <v-select
                class="style-chooser"
                v-model="updateCompanyObj.types"
                :options="companyTypes"
                :reduce="(type) => type.id"
                label="type_name"
                multiple
                :disabled="true"
              ></v-select>
            </div>
          </div>
        </div>

        <hr />

        <!-- BUTTON -->
        <div class="row">
          <div class="col-12">
            <div class="mt-2 text-center">
              <button type="submit" class="btn btn-primary me-1 w-50">
                Update Company <i class="bx bx-rocket ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>
<script>
import Layout from "@/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import companyMixin from "@/mixins/administration";
import Swal from "sweetalert2";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Company Management",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  mixins: [companyMixin],
  data() {
    return {
      createCompanyObj: {},
      updateCompanyObj: {},
      companyTypes: [],
      allCompanies: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      sortBy: "id",
      sortDesc: false,
      filterOn: [],
      filter: null,
      fields: [
        {
          key: "company_name",
          label: "Company Name",
          sortable: true,
        },
        {
          key: "types",
          label: "Company Type",
          sortable: false,
        },
        {
          key: "created_at",
          label: "Created At",
          sortable: false,
        },
        {
          key: "is_active",
          sortable: false,
        },
        {
          key: "actions",
          sortable: false,
          label: "",
        },
      ],
    };
  },
  async mounted() {
    this.$store.dispatch("layout/changeLoaderValue", true);
    this.companyTypes = await this.GetCompanyTypes();
    this.allCompanies = await this.GetAllCompanies();
    this.$store.dispatch("layout/changeLoaderValue", false);
  },
  methods: {
    showAddCompanyModal() {
      this.$bvModal.show("create-new-company-modal");
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    async createNewCompany() {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        await this.CreateNewCompany(this.createCompanyObj);
        this.createCompanyObj = {};
        this.allCompanies = await this.GetAllCompanies();
        this.$store.dispatch("layout/changeLoaderValue", false);
        this.$bvModal.hide("create-new-company-modal");
        Swal.fire("Company Created", "Company created successfully", "success");
      } catch (e) {
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Failed!", "Failed to create company", "error");
      }
    },

    showUpdateModal(company) {
      this.updateCompanyObj = {
        companyName: company.company_name,
        types: company.types,
      };

      this.$bvModal.show("update-company-modal");
    },

    async updateCompanyDetails() {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        await this.UpdateCompany(this.updateCompanyObj);
        this.allCompanies = await this.GetAllCompanies();
        this.updateCompanyObj = {};
        this.$store.dispatch("layout/changeLoaderValue", false);
        this.$bvModal.hide("update-company-modal");
        Swal.fire("Company Updated", "Company updated successfully", "success");
      } catch (e) {
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Failed!", "Failed to updated company", "error");
      }
    },

    async disableCompany(companyName) {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        await this.UpdateCompany({
          companyName: companyName,
          isActive: false,
        });
        this.allCompanies = await this.GetAllCompanies();
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire(
          "Company Disabled",
          "Company disabled successfully",
          "success"
        );
      } catch (e) {
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Failed!", "Failed to disable company", "error");
      }
    },

    async enableCompany(companyName) {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        await this.UpdateCompany({
          companyName: companyName,
          isActive: true,
        });
        this.allCompanies = await this.GetAllCompanies();
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Company Enabled", "Company enabled successfully", "success");
      } catch (e) {
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Failed!", "Failed to enabled company", "error");
      }
    },

    getStatusClass(status) {
      switch (status) {
        case true:
        case 1:
          return "bg-success";

        case false:
        case 0:
          return "bg-danger";

        default:
          return "bg-info";
      }
    },

    getSplitTypes(arr) {
      return arr.join(", ");
    },
  },
  components: {
    Layout,
    PageHeader,
  },
};
</script>